import register from '../../../../global/js/registry';
export default register('m-formstep-resume-step', () => import(/* webpackMode: "lazy" */ './m-formstep-resume-step-controller'));
